import { render, staticRenderFns } from "./EditorControlPanel.vue?vue&type=template&id=8b461a3c&scoped=true"
import script from "./EditorControlPanel.vue?vue&type=script&lang=js"
export * from "./EditorControlPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorControlPanel.vue?vue&type=style&index=0&id=8b461a3c&prod&scoped=true&lang=scss"
import style1 from "./EditorControlPanel.vue?vue&type=style&index=1&id=8b461a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b461a3c",
  null
  
)

export default component.exports